import React from 'react';
import Image from 'next/image';

const ValuePropositionAiAgent = () => {
    return (
        <div className="section-py relative bg-black">
            <div className="bg-agriculture-numbers">
            <video playsInline autoPlay muted loop className="aimlvideo h-[385px] counter-overlay-value" width="100%">
                <source src="media/aiml-section.mp4" type="video/mp4" />
            </video>
            </div>
            <div className="container xl:container mx-auto relative z-[1]">
                <div className="row grid lg:grid-cols-12 mb-10">
                    <div className="lg:col-span-8 grid">
                        <h2 className="text-white mb-2.5">
                            Value Proposition
                        </h2>
                        <p className='dark:text-[#D7DEE5] mb-0'>
                            We help enterprises build and deploy Autonomous AI Agents & Agent Orchestration systems that combine intelligence, auditability, and control. Designed for finance, operations, and service teams, our approach delivers measurable impact by merging enterprise RPA + AI, MCP integrations, and agent sandbox techniques for safe, high-performance automation.
                        </p>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-2 grid-cols-1">
                    <div>
                        <div className="voice-generator-box mb-2">
                        <Image
                            src="/img/llms-aiml/svg/ic_theproblemwesolve.svg"
                            alt="supply-chain-changing"
                            title="supply-chain-changing"
                            width={36}
                                height={36}
                        />
                        </div>
                        <p className="text-white mb-2 font-bold">The problem we solve</p>
                        <p className="text-white opacity-[0.8] mb-0 fs-md">
                            Manual, repetitive workflows across systems cause up to 30% productivity loss and slow back-office operations, impacting efficiency and scalability.
                        </p>
                    </div>
                    <div>
                        <div className="voice-generator-box mb-2">
                        <Image
                            src="/img/llms-aiml/svg/ic_ourcorecapabilities.svg"
                            alt="supply-chain-changing"
                            title="supply-chain-changing"
                           width={36}
                                height={36}
                        />
                        </div>
                        <p className="text-white mb-2 font-bold">Our core capabilities</p>
                        <p className="text-white opacity-[0.8] mb-0 fs-md">
                            Advanced MCP integrations, multi-agent orchestration, secure connector kits, comprehensive audit logs, and human-in-loop controls ensure safe and efficient automation.
                        </p>
                    </div>
                    <div>
                        <div className="voice-generator-box mb-2">
                        <Image
                            src="/img/llms-aiml/svg/ic_outcomeexamples.svg"
                            alt="supply-chain-changing"
                            title="supply-chain-changing"
                            width={36}
                                height={36}
                        />
                        </div>
                        <p className="text-white mb-2 font-bold">Measurable Outcomes</p>
                        <p className="text-white opacity-[0.8] mb-0 fs-md">
                            Achieve up to 70% reduction in manual tasks, 50% faster SLA compliance, and 99.7% accuracy with full traceability and auditability of all agent actions.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default ValuePropositionAiAgent;
